











import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import validationMixin from '@/plugins/mixins/validationMixin'
import mixins from 'vue-typed-mixins'
import RegisterModel from './model/registerModel'
import routeMixin from '@/router/routeMixin'
import Steppable from '@/global/viewmodels/steppable'

export default mixins(mobileTypeMixin, validationMixin, routeMixin).extend({
    components: { Login: () => import('./components/Login.vue') },
    data() {
        return {
            stepper: new Steppable(1, 0),
            model: new RegisterModel()
        }
    }
})
